import { Injectable } from '@angular/core';
import { ItemNavbar } from '../models/item-navbar';

@Injectable({
  providedIn: 'root',
})
export class NavbarLoaderService {
  itemsNavbar: ItemNavbar[];

  constructor() {
    const dashboard: ItemNavbar = {
      label: 'Dashboard',
      logo: 'dashboard',
      route: 'dashboard',
    };

    const feed: ItemNavbar = {
      label: 'Feed',
      logo: 'home',
      route: 'feed',
    };

    const chat: ItemNavbar = {
      label: 'Chat',
      logo: 'chat_bubble_outline',
      route: 'chat/start-conversation',
    };

    const users: ItemNavbar = {
      label: 'Users',
      logo: 'people_alt',
      route: 'people',
    };

    const profile: ItemNavbar = {
      label: 'Profile',
      logo: 'account_circle',
      route: 'profile',
    };

    const settings: ItemNavbar = {
      label: 'editProfile',
      logo: 'edit',
      route: 'edit',
    };

    const signOut: ItemNavbar = {
      label: 'Sign Out',
      logo: 'meeting_room',
      route: 'sign-out',
    };

    this.itemsNavbar = [
      dashboard,
      feed,
      chat,
      users,
      profile,
      settings,
      signOut,
    ];
  }

  getItemsLoaded() {
    return this.itemsNavbar;
  }
}
